import RewardDetailsForm from "./rewardDetailsForm.container";

export default RewardDetailsForm;